import { VStack } from "@chakra-ui/react";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { SideBarItems } from "../utils/utils";

const Sidebar = React.memo(() => {
  const loggedInUser = localStorage.getItem("userId");
  const user = loggedInUser ? JSON.parse(loggedInUser) : {};
  const super_admin = true; // main admin session grants full access
  return (
    <VStack align="start">
      {SideBarItems?.map(({ path, icon: Icon, label, value }) => (
        <>
          {super_admin && (
            <NavLink key={path} to={path} icon={Icon}>
              {label}
            </NavLink>
          )}
        </>
      ))}
    </VStack>
  );
});

const NavLink = ({ to, icon: Icon, children }) => {
  const location = useLocation();
  // Paths are /digi/blog — compare the 3rd segment (index 2)
  const pathSegment = to.split("/")[2] || "";
  const locSegment = location.pathname.split("/")[2] || "";
  const isActive = pathSegment === locSegment;
  return (
    <Link to={to} className={isActive ? "activelink" : "link"}>
      <Icon size={20} />
      {children}
    </Link>
  );
};

export default Sidebar;
